/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import * as moment from 'moment';
import {IdentifiedModel} from '../../common/identified-model.class';
import {ModelMixin} from '../../common/model.class';
import Moment = moment.Moment;

export class LicensingExamination extends ModelMixin() implements IdentifiedModel<LicensingExamination> {

    TYPE = LicensingExamination;

    id: string;
    certificationType?: string;
    mostRecentExamDate?: Moment;
    timesTaken?: number;
    completionDate?: Moment;

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.mostRecentExamDate) jsonData.mostRecentExamDate = moment(jsonData.mostRecentExamDate);
        if (jsonData.completionDate) jsonData.completionDate = moment(jsonData.completionDate);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/licensingexamination/licensing-examination.model.ts